module.exports = __webpack_public_path__ + "static/media/JLLewis.d026c439.png";